import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Loader, Table} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {warehouses} from '../../../../common/dictionaries/parameters';

class PendingItemsTable extends Component {
  componentDidMount() {
    const {agency} = this.props;
    this.props.fetchScanningPendingItemsList(agency, warehouses.main);
  }

  renderPendingItems() {
    const {agency, pendingItems} = this.props;

    if (!agency) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='4'>Seleccione una Agencia</Table.Cell>
        </Table.Row>
      );
    }

    if (!pendingItems.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='4'>No hay items pendientes</Table.Cell>
        </Table.Row>
      );
    }

    return pendingItems.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.orderSequence}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.pendingQuantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTableBody() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }

    return (
      <Table.Body>
        {this.renderPendingItems()}
      </Table.Body>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Secuencia</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {this.renderTableBody()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'agency': state.scanning.agencyData,
    'loading': state.scanning.loadingPendingItemsList,
    'pendingItems': state.scanning.pendingItemsList,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchScanningPendingItemsList,
} = Actions;

export default connect(mapStateToProps, {
  fetchScanningPendingItemsList,
})(PendingItemsTable);
